module.exports = __webpack_public_path__ + "static/media/illustration-404.15f28514.svg";